export default "__VITE_ASSET__2e0834cc__"